import React from "react"
// import Img from "gatsby-image"
// import { useStaticQuery } from "gatsby"
import SliderImage from "../../../images/home/s1.jpg"

const Slider1 = () => {
  //   const data = useStaticQuery(graphql`
  //     {
  //       file(relativePath: { eq: "slider.jpg" }) {
  //         id
  //         childImageSharp {
  //           fluid {
  //             ...GatsbyImageSharpFluid
  //           }
  //         }
  //       }
  //     }
  //   `)
  return (
    <div className="nav-over">
      <img src={SliderImage} alt="Slider1" />
    </div>
  )
  //   return <Img fluid={data.file.childImageSharp.fluid} />
}

export default Slider1
